export const request = (constant, parameter) => { return { type: constant } }
export const success = (constant, parameter) => { return { type: constant, ...parameter  } }
export const failure = (constant, parameter) => { return { type: constant, error: parameter.error, status: parameter.status } }